import React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

const SearchBar = ({
  onSearch,
  onSearchData,
  searchData,
  placeholder = 'Buscar...',
  inputGroupStyle,
}) => {
  return (
    <InputGroup
      className="mt-2 mb-2 border border-secondary rounded"
      style={{ width: 250, maxWidth: '100%', ...inputGroupStyle }}
    >
      <FormControl
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={onSearchData}
        value={searchData}
        onKeyUp={onSearch}
        style={{ border: 'none' }}
      />
      <InputGroup.Text>
        <FaSearch />
      </InputGroup.Text>
    </InputGroup>
  );
};

export default SearchBar;
